import React, { useEffect } from "react";
import ServiceBanner from "./ServiceBanner";
import ServicesList from "./ServicesList";
import LastServiceSec from "./LastServiceSec";
import ServiceArea from "./ServiceArea";
import SEO from "../SEO";
import ReactGA  from "react-ga4";

const Services = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/services",
      title: "Services Offered by SynergyCare Foundation",
    });
  });
	return (
		<>
			<SEO
				title='Services Offered by SynergyCare Foundation'
				description='Explore the services provided by AccessCareConnect Referral Foundation, including patient support, provider partnerships, and advocacy.'
				name='SynergyCare Foundation'
				type=''
			/>
			<ServiceBanner />
			<ServicesList />
			<ServiceArea />
			<LastServiceSec />
		</>
	);
};

export default Services;
